import { render, staticRenderFns } from "./new-pro-video.vue?vue&type=template&id=2ef82400&scoped=true&"
import script from "./new-pro-video.vue?vue&type=script&lang=js&"
export * from "./new-pro-video.vue?vue&type=script&lang=js&"
import style0 from "./new-pro-video.vue?vue&type=style&index=0&id=2ef82400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef82400",
  null
  
)

export default component.exports